import { Pipe } from '@angular/core';
import { isObject } from '../helpers/helpers';
var OmitPipe = (function () {
    function OmitPipe() {
    }
    OmitPipe.prototype.transform = function (obj) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (Array.isArray(obj) || !isObject(obj)) {
            return obj;
        }
        return Object.keys(obj)
            .filter(function (k) { return !~args.indexOf(k); })
            .reduce(function (o, k) {
            return Object.assign(o, (_a = {}, _a[k] = obj[k], _a));
            var _a;
        }, {});
    };
    return OmitPipe;
}());
export { OmitPipe };
OmitPipe.decorators = [
    { type: Pipe, args: [{ name: 'omit' },] },
];
/** @nocollapse */
OmitPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=omit.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/object/omit.js
// module id = 251
// module chunks = 4